module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


// WEBPACK FOOTER //
// ./node_modules/babel-runtime/core-js/object/define-property.js